import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import { getUrlWithQueryStringUtil } from 'packages/src'
import { SUBSCRIPTION_PLAN } from '@gymaholic/packages'

export function getPremiumPlusYearlyUrlUtil ({
  shouldShowUpgradeDiscount,
  shouldShowNewCustomerDiscount
} = {}) {
  let plan
  if (shouldShowUpgradeDiscount) {
    plan = SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_UPGRADE_2025
  } else if (shouldShowNewCustomerDiscount) {
    plan = SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_SALE_2025
  } else {
    plan = SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_2025
  }
  return getUrlWithQueryStringUtil(ROUTE_PATH.PREMIUM, { plan })
}
